const header = document.getElementsByTagName('meta')['_csrf_header'].getAttribute('content');
window._csrf = {
  [header]: document.getElementsByTagName('meta')['_csrf'].getAttribute('content'),
};

window.$_csrf = window._csrf;
